import { render, staticRenderFns } from "./PaymentFormContainer.vue?vue&type=template&id=8f48a5ea"
import script from "./PaymentFormContainer.vue?vue&type=script&lang=js"
export * from "./PaymentFormContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports